import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../../Redux/Actions/actionTypes";
import {
  doLoadingStart,
  doLoadingFinish,
} from "../../Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import AccountCreateRequest from "../../Communication/ApiClasses/AccounCreateRequest";

// worker
function* handleAccountCreate(action) {
  yield put(doLoadingStart(actionTypes.ACCOUNT_CREATE));

  const accountCreateRequest = new AccountCreateRequest(action.data);
  try {
    const result = yield call(accountCreateRequest.getData);
    yield put({
      type: `${actionTypes.ACCOUNT_CREATE}_SUCCESS`,
      response: result.data,
    });
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: `${actionTypes.ACCOUNT_CREATE}_ERROR`,
      error,
    });
    yield call(action.callback, { error });
  } finally {
    yield put(doLoadingFinish(actionTypes.ACCOUNT_CREATE));
  }
}

// watcher
export default function* accountCreateSaga() {
  yield takeLatest(actionTypes.ACCOUNT_CREATE, handleAccountCreate);
}
